import messages from '../../locale/messages';
import { containsMalicious, inputTextLimit, strongPassword } from '../../helpers/textRestriction';


function isValidURL(url) {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}
const validate = (values) => {
  const errors = {};

  if (!values.listingUrl) {
    errors.listingUrl = messages.required;
  } else if (!isValidURL(values.listingUrl)) {
    errors.listingUrl = messages.listingUrlInvalid;
  }
  
  return errors;
};

export default validate;
